import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IRefreshTokenRequest, IRefreshTokenResponse } from '../models/refresh-token.model';

// refresh token
export const loadRefreshTokenRequest = createAction(
  '[RefreshToken] Load Refresh Token Request',
  props<{ request: IRefreshTokenRequest }>()
);
export const loadRefreshTokenSuccess = createAction(
  '[RefreshToken] Load Refresh Token Success',
  props<{ response: IRefreshTokenResponse }>()
);
export const loadRefreshTokenFailure = createAction(
  '[RefreshToken] Load Refresh Token Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
export const clearRefreshToken = createAction('[RefreshToken] Clear Refresh Token');
